import React from 'react';
import {inject, observer} from 'mobx-react';
import { Tabs } from 'antd';

const TabPane = Tabs.TabPane;
@inject('headerStore')
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'order-header',
  }  

  componentDidMount() {
    const { location: { query }, headerStore: { setMobxState, init } } = this.props;
    init();
    if(query.id) {
      setMobxState({activeKey: query.id});
    }
  }

  onChange = (activeKey) => {
    const { location: { query}, headerStore: { setMobxState, routing } } = this.props;
    setMobxState({ activeKey });
    routing.push({
      pathname: '/app/order',
      query: {
        ...query,
        id: activeKey,
      }
    })
  }
  render() {
    const { prefixCls, headerStore: { activeKey } } = this.props;
    return (
      <div className={prefixCls}>
        <Tabs activeKey={activeKey} onChange={this.onChange}>
          <TabPane tab="应用订单" key="app" />
          <TabPane tab="ecode订单" key="ecode" />
        </Tabs>
        { this.props.children }
      </div>
    )
  }

}

export default App


// WEBPACK FOOTER //
// ./src/components/order/HeaderOrder.js